module.exports = __webpack_public_path__ + "img/stopper-watch.6cfabe44.svg";